import { z } from "zod";

// ─── Currencies ──────────────────────────────────────────────────────────────
export const currencyIdSchema = z.string().uuid("ID de moneda inválido");

export const createCurrencySchema = z.object({
  code: z.string().min(1, "El código es requerido").max(10).toUpperCase(),
  name: z.string().min(1, "El nombre es requerido").max(200),
});

export const updateCurrencySchema = createCurrencySchema.partial();

export const currencyQuerySchema = z.object({
  deleted: z.enum(["true", "false"]).optional(),
});

// ─── Exports ─────────────────────────────────────────────────────────────────
export type CurrencyId = z.infer<typeof currencyIdSchema>;
export type CreateCurrency = z.infer<typeof createCurrencySchema>;
export type UpdateCurrency = z.infer<typeof updateCurrencySchema>;
export type CurrencyQuery = z.infer<typeof currencyQuerySchema>;
